import React, {Component} from 'react'

class LoginComponent extends Component{
	render(){
		return(
		 <div className="Login-page">
		   <header className="Login-header">
		    <h1 style={{fontSize: "50pt"}}>Bahtah Login</h1>
		   </header>
		   <br/><br/><br/>
		   <div className="Login-body">
		    <form>
		     <table>
		      <tbody>
		       <tr>
		        <td>
			 <label>Username:</label>
		        </td>
		        <td>
		         <input style={{color: "black", marginLeft: "20px"}}/>
		        </td>
		       </tr>
		       <br/>
		       <tr>
		        <td>
		         <label>Password:</label>
		        </td>
		        <td>
		         <input type="password" style={{color: "black", marginLeft: "20px"}}/>
		        </td>
		       </tr>
		      </tbody>
		     </table>
	            </form>
		   </div>
		  </div>
		)	
	}
}

export default LoginComponent
